import { useEffect } from 'react';
import isBrowser from 'is-browser';

/**
 * Hook to prevent body scrolling when a modal/overlay is open
 * @param isLocked - Whether to lock the body scroll
 * @param enabled - Whether the hook is enabled (e.g., only on mobile)
 */
export const useBodyScrollLock = (
  isLocked: boolean,
  enabled: boolean = true
) => {
  useEffect(() => {
    if (!isBrowser || !enabled) return;

    if (isLocked) {
      // Save the current scroll position
      const scrollY = window.scrollY;

      // Prevent scrolling by setting overflow hidden and position fixed
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
    } else {
      // Restore scrolling
      const scrollY = document.body.style.top;

      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.style.overflow = '';

      // Restore scroll position
      if (scrollY) {
        window.scrollTo(0, parseInt(scrollY || '0') * -1);
      }
    }

    // Cleanup function
    return () => {
      if (isBrowser && enabled && isLocked) {
        const scrollY = document.body.style.top;
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        document.body.style.overflow = '';
        if (scrollY) {
          window.scrollTo(0, parseInt(scrollY || '0') * -1);
        }
      }
    };
  }, [isLocked, enabled]);
};
